import { render } from "./Detail.vue?vue&type=template&id=7041c47a&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=7041c47a&lang=scss&scoped=true"

import exportComponent from "/data/jenkins-workspace/workspace/Publicar_automáticamente_por_Lianxin/联心运营后台前端【生产】/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7041c47a"]])

export default __exports__